 
export const isDev = () => process.env.NODE_ENV === 'development';
export const isProd = () => !isDev();
// eslint-disable-next-line eqeqeq
export const isServer = () => typeof window == 'undefined';
export const isBrowser = () => !isServer();